import inventoryTransferDetailApi from '../../../api/inventory/transfer/inventoryTransferDetailApi';

const InventoryTransferDetailService = {
    /**
     * ➕ Agrega un producto al traslado
     * POST /api/inventory/transfers/details/{transferId}
     */
    addDetail: async (transferId: number, payload: any) => {
        const response = await inventoryTransferDetailApi.addCustom(
            `/${transferId}`,
            payload
        );
        return response.data;
    },

    /**
     * ✏️ Actualiza la cantidad de un producto del traslado
     * PUT /api/inventory/transfers/details/{detailId}
     */
    updateDetail: async (detailId: number, payload: any) => {
        const response = await inventoryTransferDetailApi.modifyCustom(
            `/${detailId}`,
            payload
        );
        return response.data;
    },

    /**
     * ❌ Elimina un producto del traslado
     * DELETE /api/inventory/transfers/details/{detailId}
     */
    deleteDetail: async (detailId: number) => {
        const response = await inventoryTransferDetailApi.removeCustom(
            `/${detailId}`
        );
        return response.data;
    },

    /**
     * 🔍 Lista los productos de un traslado
     * GET /api/inventory/transfers/details/by-transfer/{transferId}
     */
    getByTransfer: async (transferId: number) => {
        const response = await inventoryTransferDetailApi.fetchCustom(
            `/by-transfer/${transferId}`
        );
        return response.data;
    },

    /**
     * 🔍 Obtiene un producto del traslado por ID
     * GET /api/inventory/transfers/details/details/{detailId}
     */
    getById: async (detailId: number) => {
        const response = await inventoryTransferDetailApi.fetchCustom(
            `/details/${detailId}`
        );
        return response.data;
    },
};

export default InventoryTransferDetailService;
